import type { ReactNode } from 'react'
import { AlertTriangle, Loader2 } from 'lucide-react'
import { fehlerText } from '../../lib/api'

export function Laden({ text, hinweis, kompakt = false }: { text: string; hinweis?: string; kompakt?: boolean }) {
  return (
    <div className={`q-state${kompakt ? ' q-state--compact' : ''}`} role="status" aria-live="polite">
      <Loader2 className="q-spin" aria-hidden="true" />
      <span>{text}</span>
      {hinweis && <span className="q-state-hint">{hinweis}</span>}
    </div>
  )
}

export function Fehler({ fehler, nochmal, kompakt = false }: { fehler: unknown; nochmal?: () => void; kompakt?: boolean }) {
  return (
    <div className={`q-state q-state--error${kompakt ? ' q-state--compact' : ''}`} role="alert">
      <AlertTriangle aria-hidden="true" width={20} height={20} />
      <span>{fehlerText(fehler)}</span>
      {nochmal && (
        <button type="button" className="q-btn q-btn-ghost q-btn-sm" onClick={nochmal}>
          Erneut versuchen
        </button>
      )}
    </div>
  )
}

export function Leer({ text, aktion, kompakt = false }: { text: string; aktion?: ReactNode; kompakt?: boolean }) {
  return (
    <div className={`q-state${kompakt ? ' q-state--compact' : ''}`}>
      <span>{text}</span>
      {aktion}
    </div>
  )
}

export function SkeletonZeilen({ anzahl = 5 }: { anzahl?: number }) {
  return (
    <div aria-hidden="true">
      {Array.from({ length: anzahl }, (_, i) => (
        <div key={i} className="q-skel-row">
          <span className="q-skel" />
          <span className="q-skel" style={{ width: `${55 + ((i * 17) % 35)}%` }} />
          <span className="q-skel" />
          <span className="q-skel" />
        </div>
      ))}
    </div>
  )
}
